@if ( globalEvaluationService && globalEvaluationService.status != null &&
!loading) { @if (globalEvaluationService.status >= 3) {
  <div
    class="pia-evaluationBlock"
    [ngClass]="{
    'pia-evaluationBlock-shadowed': item.evaluation_mode === 'item'
  }"
  >
  <div
    [ngClass]="{
      'pia-evaluationBlock-self-padding': item.evaluation_mode === 'item'
    }"
  >
    <div class="pia-evaluationBlock-title">
      {{ "evaluations.title" | translate }}
    </div>
    @if (evaluation) {
    <form [formGroup]="evaluationForm">
      <!-- Buttons -->
      <div class="pia-evaluationBlock-buttons">
        <button
          class="btn btn-red"
          [ngClass]="{ 'btn-active': evaluation.status === 1 }"
          [disabled]="
            evaluation.status === 1 ||
            !globalEvaluationService.evaluationEditionEnabled ||
            loading ||
            (!editMode.includes('evaluator') && editMode !== 'local')
          "
          (click)="selectedButton($event, 1)"
          name="fix"
          type="submit"
          title="{{ 'evaluations.to_correct' | translate }}"
        >
          <fa-icon [icon]="faXmark"></fa-icon>
          {{ "evaluations.to_correct" | translate }}
        </button>
        @if (section.id !== 1) {
        <button
          class="btn btn-blue"
          [ngClass]="{ 'btn-active': evaluation.status === 2 }"
          [disabled]="
            evaluation.status === 2 ||
            !globalEvaluationService.evaluationEditionEnabled ||
            loading ||
            (!editMode.includes('evaluator') && editMode !== 'local')
          "
          (click)="selectedButton($event, 2)"
          name="improvable"
          type="submit"
          title="{{ 'evaluations.improvable' | translate }}"
        >
          <fa-icon [icon]="faCircleNotch"></fa-icon>
          {{ "evaluations.improvable" | translate }}
        </button>
        }
        <button
          class="btn btn-green"
          [ngClass]="{ 'btn-active': evaluation.status === 3 }"
          [disabled]="
            evaluation.status === 3 ||
            !globalEvaluationService.evaluationEditionEnabled ||
            loading ||
            (!editMode.includes('evaluator') && editMode !== 'local')
          "
          (click)="selectedButton($event, 3)"
          name="acceptable"
          type="submit"
          title="{{ 'evaluations.acceptable' | translate }}"
        >
          <fa-icon [icon]="faCheck"></fa-icon>
          {{ "evaluations.acceptable" | translate }}
        </button>
      </div>
      <div
        class="pia-evaluationBlock-content pia-evaluationBlock-measure-{{
          measureId
        }} pia-evaluationBlock-question-{{ questionId }} fadeIn"
        [ngClass]="{ hide: evaluation.status <= 0 }"
      >
        <time class="pia-evaluationBlock-date">{{
          evaluation.created_at
            | date: "shortDate":"":languagesService.selectedLanguage
        }}</time>
        <!-- Evaluation fields -->
        <!-- All evaluations : comment field -->
        <div
          [ngClass]="{
            hide:
              globalEvaluationService.status >= 7 &&
              (!evaluation.evaluation_comment ||
                evaluation.evaluation_comment.length <= 0)
          }"
        >
          <label for="pia-evaluation-comment-{{ evaluation.id }}">{{
            "evaluations.evaluation_comment" | translate
          }}</label>
          <div
            (click)="evaluationCommentFocusIn()"
            class="pia-evaluationBlock-contentText"
            [innerHTML]="
              evaluationForm.controls['evaluationComment'].value | safeHtml
            "
            [ngClass]="{
              hide:
                editorEvaluationComment ||
                !evaluationForm.controls['evaluationComment'].value
            }"
          ></div>
          @if (editMode.includes('evaluator') || editMode === 'local') {
          <textarea
            (keyup)="autoTextareaResize($event)"
            id="{{ evaluationCommentElementId }}"
            rows="8"
            cols="50"
            formControlName="evaluationComment"
            name="pia-evaluation-comment"
            [attr.disabled]="
              globalEvaluationService.evaluationEditionEnabled ? null : true
            "
            (focusin)="evaluationCommentFocusIn()"
            [ngClass]="{
              hide:
                hideTextareaEvaluationComment ||
                globalEvaluationService.status >= 7
            }"
            [attr.placeholder]="comment_placeholder"
          ></textarea>
          }
        </div>
        <!-- Action plan evaluation : special action plan comment field -->
        @if (evaluation.status === 2) {
        <div class="pia-evaluationBlock-actionPlan fadeIn">
          <label for="pia-evaluation-action-plan-{{ reference_to }}">{{
            "evaluations.action_plan_comment" | translate
          }}</label>
          <div
            (click)="actionPlanCommentFocusIn()"
            class="pia-evaluationBlock-contentText"
            [innerHTML]="
              evaluationForm.controls['actionPlanComment'].value | safeHtml
            "
            [ngClass]="{
              hide:
                editorActionPlanComment || !evaluationForm.controls['actionPlanComment'].value
            }"
          ></div>
          <textarea
            (keyup)="autoTextareaResize($event)"
            id="{{ actionPlanCommentElementId }}"
            rows="8"
            cols="50"
            formControlName="actionPlanComment"
            name="pia-evaluation-action-plan"
            [attr.disabled]="
              globalEvaluationService.evaluationEditionEnabled ? null : true
            "
            (focusin)="actionPlanCommentFocusIn()"
            [ngClass]="{
              hide:
                hideTextareaActionPlanComment ||
                globalEvaluationService.status >= 7
            }"
            placeholder="{{
              'evaluations.placeholder_improvable1' | translate
            }}"
          ></textarea>
        </div>
        }
        <!-- Gauges -->
        @if ( item.evaluation_mode === 'item' && item.evaluation_with_gauge ===
        true && evaluation.status === 2 ) {
        <div>
          <p
            class="pia-evaluationBlock-gauge"
            [innerHTML]="'evaluations.gauges.seriousness' | translate"
          ></p>
          <div class="pia-gaugeBlock">
            <input
              type="range"
              (focus)="enableGaugeX()"
              (change)="checkGaugeChanges($event, 'x')"
              formControlName="gaugeX"
              min="0"
              max="4"
              step="1"
            />
            <div>
              <div>{{ "evaluations.gauges.0" | translate }}</div>
              <div>{{ "evaluations.gauges.1" | translate }}</div>
              <div>{{ "evaluations.gauges.2" | translate }}</div>
              <div>{{ "evaluations.gauges.3" | translate }}</div>
              <div>{{ "evaluations.gauges.4" | translate }}</div>
            </div>
            <div
              class="pia-gaugeBlock-user-choice pia-gaugeBlock-user-choice-{{
                previousGauges.x
              }}"
            ></div>
            @if (evaluation.gauges) {
            <div
              class="pia-gaugeBlock-background pia-gaugeBlock-background-x pia-gaugeBlock-background-{{
                evaluation.gauges['x']
              }}"
            ></div>
            }
          </div>
          <p
            class="pia-evaluationBlock-gauge"
            [innerHTML]="'evaluations.gauges.likelihood' | translate"
          ></p>
          <div class="pia-gaugeBlock">
            <input
              type="range"
              (focus)="enableGaugeY()"
              (change)="checkGaugeChanges($event, 'y')"
              formControlName="gaugeY"
              min="0"
              max="4"
              step="1"
            />
            <div>
              <div>{{ "evaluations.gauges.0" | translate }}</div>
              <div>{{ "evaluations.gauges.1" | translate }}</div>
              <div>{{ "evaluations.gauges.2" | translate }}</div>
              <div>{{ "evaluations.gauges.3" | translate }}</div>
              <div>{{ "evaluations.gauges.4" | translate }}</div>
            </div>
            <div
              class="pia-gaugeBlock-user-choice pia-gaugeBlock-user-choice-{{
                previousGauges.y
              }}"
            ></div>
            @if (evaluation.gauges) {
            <div
              class="pia-gaugeBlock-background pia-gaugeBlock-background-y pia-gaugeBlock-background-{{
                evaluation.gauges['y']
              }}"
            ></div>
            }
          </div>
        </div>
        }
      </div>
    </form>
    }
  </div>
</div>
} } @else {
<div class="pia-sectionBlock-body" style="position:relative; height: 150px;">
  <app-loading-overlay
    [visibility]="true"
    [childMode]="true"
  ></app-loading-overlay>
</div>
}
